// Force a browser download of a Blob (as returned by an RTK Query blob endpoint).
// Unlike openPdfBlob, this always saves the file rather than opening a tab, which
// is the right behaviour for non-previewable files like .xlsx.
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
